import { Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Sidebar from './Sidebar'
import TopNav from './TopNav'
import ImpersonationBanner from './ImpersonationBanner'
import DashboardFooter from './DashboardFooter'
import ToastContainer from '@/components/ui/ToastContainer'
import { useToastStore } from '@/hooks/useToast'
import { useAuth } from '@/hooks/useAuth'
import { authApi } from '@/services/api'

export default function MainLayout() {
  const { toasts, removeToast } = useToastStore()
  const { updateUser } = useAuth()

  // Keep user data in sync with auth store
  useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const response = await authApi.me()
      if (response.success && response.data?.user) {
        updateUser(response.data.user)
      }
      return response.data?.user
    },
    staleTime: 10000, // 10 seconds
    refetchOnMount: false,
  })

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopNav />
        <ImpersonationBanner />
        <main className="flex-1 p-6 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </main>
        <DashboardFooter />
      </div>
      <ToastContainer toasts={toasts} onClose={removeToast} />
    </div>
  )
}
